var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    style: {
      flex: "none",
      lineHeight: 1
    },
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gemini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z",
    fill: "#3186FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z",
    fill: "url(#lobe-icons-gemini-fill-0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z",
    fill: "url(#lobe-icons-gemini-fill-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z",
    fill: "url(#lobe-icons-gemini-fill-2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "lobe-icons-gemini-fill-0",
    x1: 7,
    x2: 11,
    y1: 15.5,
    y2: 12
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08B962",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "lobe-icons-gemini-fill-1",
    x1: 8,
    x2: 11.5,
    y1: 5.5,
    y2: 11
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F94543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94543",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "lobe-icons-gemini-fill-2",
    x1: 3.5,
    x2: 17.5,
    y1: 13.5,
    y2: 12
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FABC12",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiLogo);
export default __webpack_public_path__ + "static/media/gemini-logo.12533c050952f284cec6eb0f5841e868.svg";
export { ForwardRef as ReactComponent };